/* eslint-disable */
import React, { useState, useEffect, InputHTMLAttributes } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { Trans } from 'react-i18next';

import { Input, InputStateProps } from '../Input/Input';
import Heading from '../Heading/Heading';

import './SelectionFormGroup.scss';
import useTranslation from '../../hooks/useTranslation';
/**
 * This component by default is a checkbox input.
 */
interface SelectionFormGroupProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value'>, InputStateProps {
  // id: string,
  label: React.ReactNode;
  // error?: string,
  // dirty?: boolean,
  // touched?: boolean,
  // name: string,
  value?: string;
  errorClassName?: string;
  type?: string;
  checked?: boolean;
  iconClassName?: string;
  // onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
  // onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void,
}

function SelectionFormGroup({
  id,
  label,
  error,
  dirty,
  touched,
  name,
  value,
  errorClassName,
  type = 'checkbox',
  checked,
  // 'aria-invalid': ariaInvalid,
  // 'aria-describedby': ariaDescribedBy,
  iconClassName,
  onChange,
  onBlur,
}: SelectionFormGroupProps) {
  const shouldDisplayErrors = !!(touched && dirty && error);
  const errorMessageID = `input-error-${name}`;
  const { translateText, i18n } = useTranslation();
  const [dir, setDir] = useState(i18n.dir());
  useEffect(() => {
    setDir(i18n.dir());
  }, [i18n, i18n.language]);

  return (
    <>
      <div className="selection-form-group">
        <label className={type === 'radio' ? 'ies-radio-label' : ''} htmlFor={id} data-tooltip-id={id}>
          <Input
            name={name}
            id={id}
            onChange={onChange}
            onBlur={onBlur}
            type={type}
            className={type === 'checkbox' ? 'checkbox' : 'ies-radio'}
            aria-invalid={shouldDisplayErrors}
            aria-describedby={errorMessageID}
            value={value}
            checked={checked}
          />
          {type === 'checkbox' && (
            <span className={`${shouldDisplayErrors && 'errors'} ${iconClassName ?? 'checkmark'}`} />
          )}
          <span className={type === 'checkbox' ? 'checkbox-label-text' : 'ies-radio-label-text'}>{label}</span>

          {shouldDisplayErrors && (
            <div aria-live="assertive" id={errorMessageID} className={errorClassName} role="alert">
              {error}
            </div>
          )}
        </label>
      </div>
      <ReactTooltip
        id="remember-me-tooltip"
        place="left"
        variant="light"
        className="remember-tooltip"
      >
        <div>
          <Heading Tag="h3" addClasses="">
            {translateText('Remember me')}
          </Heading>
          <br />
          <Trans i18nKey="rememberMeTooltipContent">
            Choosing 'Remember me' reduces the number of times you are asked to Sign in on this device. <span className="remember-tooltip--emphasis">To keep your account secure, use this option only on your personal devices.</span>
          </Trans>
        </div>
      </ReactTooltip>
    </>
  );
}

export default React.memo(SelectionFormGroup);
